import React, { useEffect, useState } from "react";
import { Container, Nav } from "react-bootstrap";
import Link from "next/link";
import * as s from "./index.module.scss";
import secondaryFont from "@/utils/secondaryFont";
import links from "./utils/data";
import AccreditedImage1 from "../../../images/BBB Accredited Business.png";
import { PrismicRichText } from "@prismicio/react";
import ChevronDown from "atd-icons/dist/ChevronDown";
import ChevronUp from "atd-icons/dist/ChevronUp";
import Socials from "./socials";

const Footer = ({ data }) => {
  const [year, setYear] = useState("");
  useEffect(() => {
    const temp = new Date().getFullYear();
    setYear(temp);
  }, []);

  const [openIndex, setOpenIndex] = useState(null);

  const toggleSubLink = (index) => {
    setOpenIndex((prev) => (prev === index ? null : index));
  };

  return (
    <footer className={s.footer}>
      <Container>
        <div className={s.footer_wrapper}>
          <div className={s.footer_details}>
            <img
              loading="lazy"
              src={data?.logo_image.url}
              alt="logo"
              height="100%"
            />
            <div
              className={`text-center text-md-start mb-4 ${secondaryFont} ${s.address_text}`}
            >
              {/* New York’s top rated buyer of luxury watches, diamonds, gold and other luxury items with 20+ years in business.  */}
              <PrismicRichText field={data?.footer_description || []} />
            </div>
            <div
              className={`text-center text-md-start mb-4 mb-md-0 ${secondaryFont} ${s.address_text}`}
            >
              <PrismicRichText field={data?.address || []} />
            </div>
            <Socials socials={data?.socials} />
          </div>

          <div
            className={`d-flex justify-content-between align-items-start flex-wrap flex-lg-nowrap ${s.footer_links_wrapper}`}
          >
            {links.map(({ title, links }, idx) => {
              return (
                <div className={s.footer_links} key={idx}>
                  <p className={secondaryFont}>{title}</p>
                  <ul
                    className={`ps-0 ${s.footer_nav} ${idx === 0 ? s.min_w_footer : ""}`}
                  >
                    {links.map(({ title, link, subLinks }, index) => {
                      const isOpen = openIndex === index;
                      return (
                        <Nav.Link as="li" key={index}>
                          <div
                            className="d-flex align-items-center"
                            onClick={() => toggleSubLink(index)}
                            role="button"
                          >
                            {subLinks && subLinks.length > 0 ? (
                              <p className={`${secondaryFont}`}>{title}</p>
                            ) : (
                              <Link href={link} className={`${secondaryFont}`}>
                                {title}
                              </Link>
                            )}

                            {subLinks && subLinks.length > 0 && (
                              <span className={s.icon_stack}>
                                {isOpen ? (
                                  <ChevronUp size={24} />
                                ) : (
                                  <ChevronDown size={24} />
                                )}
                              </span>
                            )}
                          </div>

                          {subLinks && subLinks.length > 0 && (
                            <ul
                              style={{
                                listStyleType: "none",
                                paddingLeft: "12px",
                              }}
                              className={`${s.sub_links} ${isOpen ? s.show_sub_links : ""}`}
                            >
                              {subLinks.map((subLink, subIndex) => {
                                return (
                                  <li
                                    key={subIndex}
                                    className={s.sub_link_item}
                                  >
                                    <Link
                                      href={subLink.link}
                                      className={secondaryFont}
                                    >
                                      {subLink.title}
                                    </Link>
                                  </li>
                                );
                              })}
                            </ul>
                          )}
                        </Nav.Link>
                      );
                    })}
                  </ul>
                </div>
              );
            })}
            <div className={s.footer_links}>
              <div className={s.accredited_imgs}>
                <a
                  href="https://www.bbb.org/us/ny/new-york/profile/jewelry-buyers/manhattan-buyers-inc-0121-123872"
                  target="_blank"
                >
                  <img
                    loading="lazy"
                    src={AccreditedImage1.src}
                    alt="logo"
                    height="100%"
                  />
                </a>
              </div>
            </div>
          </div>
        </div>
        <div className={s.copyrights}>
          <div className={secondaryFont}>
            <Link href={"/terms-and-conditions"}>Terms and conditions</Link>
            <span className="text-white"> | </span>
            <Link href={"/privacy-policy"}>Privacy Policy</Link>
          </div>

          <div>
            <p className={secondaryFont}>
              ©{year} - Manhattan Buyers | All right reserved
            </p>
          </div>
        </div>
        <div className={`${s.footer_bottom_text} extra-small ${secondaryFont}`}>
          Manhattan Buyers Inc is an independent watch dealer and is not
          sponsored by, associated with and/or affiliated with A. Lange & Sohne,
          Audemars Piguet, Bell & Ross, Blancpain, Breguet, Breitling, BVLGARI,
          Cartier, Chanel, Chopard, Chronoswiss, Corum, F.P. Journe, Franck
          Muller, Girard Perregaux, Glashutte Original, Grand Seiko, Hublot,
          IWC, Jaeger-Lecoultre, Longines, Maurice, Lacroix, Montblanc, Omega,
          Panerai, Patek Philippe, Piaget, Rolex S.A., Rolex USA, Tag Heuer,
          Tudor, U-boat, Ulysse Nardin, Vacheron Constantin, Zenith etc. or any
          of these companies's subsidiaries. Manhattan Buyers Inc only buys
          pre-owned watches using a secure 3rd party service provided by
          Escrow.com. If you're looking to buy a new watch please visit these
          brands's websites for a list of authorized dealers near you.
        </div>
      </Container>
    </footer>
  );
};

export default Footer;
